import Search from 'tm/employees/Search'
import Detail from 'tm/employees/Detail'

export default {
  Search,
  Detail,
}
